import { defineComponent as a, computed as i, createBlock as s, openBlock as l, withCtx as m, createVNode as p } from "vue";
import d from "./Button.js";
import u from "./Icon.js";
const k = /* @__PURE__ */ a({
  __name: "ChevronToggle",
  props: {
    direction: { default: "down" }
  },
  emits: ["click"],
  setup(o, { emit: n }) {
    const c = o, r = n, t = i(() => `chevron-${c.direction}`);
    return (f, e) => (l(), s(d, {
      class: "stash-chevron-toggle",
      icon: "",
      "data-test": "stash-chevron-toggle",
      onClick: e[0] || (e[0] = (v) => r("click"))
    }, {
      default: m(() => [
        p(u, {
          name: t.value,
          "data-test": `icon|${t.value}`
        }, null, 8, ["name", "data-test"])
      ]),
      _: 1
    }));
  }
});
export {
  k as _
};
//# sourceMappingURL=ChevronToggle.vue_vue_type_script_setup_true_lang-Ce_qOXfR.js.map
